<template>
  <div class="top-banner-container">
    <div class="safe-area">
      <div class="logo">
        <div class="icon">5kbps.com</div>
        <div class="sign">All those moments will be lost in time</div>
      </div>
      <div class="menus">
        <router-link tag="span"
          :to="m.to"
          :class="{item: true}"
          v-for="(m, mi) in menus"
          :key="mi">{{m.label}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        { label: '笔记', to: '/notes' },
        { label: '相册', to: '/photos' },
        { label: '玩具', to: '/enjoy' },
        { label: 'Remote', to: '/remote' },
      ],
      menuIndex: 0,
    }
  }
}
</script>

<style lang="less" scoped>
.top-banner-container {
  font-size: 14px;
  position: sticky;
  top: 0;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(33,33,33,.2);
  padding: 10px 0;

  & .logo {
    vertical-align: top;
    display: inline-block;
    font-family: "Source Sans Pro", sans-serif;

    & .icon {
      font-size: 18px;
      font-weight: 600;
    }

    & .sign {
      font-size: 10px;
      font-style: italic;
      color: #aaa;
    }
  }

  & .menus {
    font-size: 12px;
    vertical-align: top;
    margin-left: 3em;
    display: inline-block;
    & .item {
      display: inline-block;
      line-height: 40px;
      margin-left: 5px;
      padding: 0 var(--gap-size);
      cursor: pointer;
      user-select: none;
    }
    & .item:hover {
      background-color: #efefef;
    }
    & .item.router-link-active {
      font-weight: bold;
      background-color: #0781f4;
      color: white;
    }
  }
}
@media screen and (max-width: 550px) {
.top-banner-container {
  top: -50px;
  & .menus {
    display: block;
    text-align: center;
    margin: 10px 0 -5px 0;
    & .item {
      line-height: 1.5;
      margin: 0 5px;
      padding: 0.2em 1em;
      background-color: #efefef;
      border-radius: 50px;
    }
    & .item.active {
      background-color: #0781f4;
      color: white;
    }
  }
}}
</style>


// WEBPACK FOOTER //
// src/components/TopBanner.vue